<template>

<div id="tableAllProduct">
  <div id="nav">
      <router-link v-if="isLogin === true" to='/all-product'>All Product |</router-link> 
      <a v-if="isLogin === true" @click="logOut()">Log Out</a>
    </div>

  <!-- {{ this.$store.state.username }} -->
    <div id="addProduct">
    <button class="button" v-on:click="addProductPage()">Add product</button>
    </div>
  <table class="table">
      <thead>
          <th>No.</th>
          <th>Gambar</th>
        <th>Nama</th>
        <th>Price</th>
        <th>Stock</th>
        <th>Option</th>
      </thead>
      
          <ProductList></ProductList>
      
  </table>
</div>
</template>

<script>
import ProductList from '../components/ProductList'
import { ParticlesBg } from "particles-bg-vue"
export default {
  data () {
    return {
    
    }
  },
  components: {
    ProductList,
    ParticlesBg
  },
  methods: {
    addProductPage () {
      this.$router.push({ name: 'AddProduct' })
    },
     logOut () {
      this.$store.dispatch('logOut')
      this.$router.push({name:'Login'})
    }
  },
  created () {
    if(!localStorage.token){
      this.$router.push({ name: 'Login' })
    }
  },
  computed:{
    isLogin(){
      return this.$store.state.isLogin
    }
  }
}
</script>

<style>
#addProduct{

    justify-content: left;
    text-align: left;
}
.button{
    background-color: rgb(200, 243, 245);
}

.img{
    width: 100px;
    height: 100px;
}

.bot-btn{
    margin-right: 10px;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
